import { prospectDemoReferenceExecution } from "@clickdialog/solution-contract";
import type { DemoManifest } from "../../../types";

const EXECUTION = prospectDemoReferenceExecution("beauty.salons.reference-v2");
if (
  !EXECUTION ||
  EXECUTION.target.kind !== "platform-path" ||
  !EXECUTION.target.requiredOrganizationSlug
) {
  throw new Error("beauty_salons_reference_execution_invalid");
}

export const BEAUTY_SALONS_REFERENCE_DEMO: DemoManifest = Object.freeze({
  id: "beauty.salons.reference-v2",
  name: "Studio Belleza Demo — Salons V2",
  vertical: "Beauty / Salons",
  industryKey: "beauty",
  industryLabel: "Beauty / Salons",
  nicheKey: "salons",
  nicheLabel: "Salons",
  subnicheLabel: "Appointment-based beauty",
  solutionKey: "salons-operations",
  solutionLabel: "Operaciones",
  demoType: "reference",
  maturity: "certified",
  runtimeStatus: EXECUTION.runtimeStatus,
  status: "reference",
  statusLabel: "Referencia certificada",
  summary: "Recorrido comercial certificado de ClickDialog for Salons V2 sobre la organización local salon-demo.",
  scopeLabel: "Referencia de ventas · Platform + operación de Salons",
  capabilities: Object.freeze([
    "Inicio operativo",
    "Conversaciones",
    "Agenda",
    "Clientes",
    "Ventas y cobros",
    "Reportes",
    "Administración",
  ]),
  launch: Object.freeze({
    kind: "organization-salons-reference",
    organizationSlug: EXECUTION.target.requiredOrganizationSlug,
    path: EXECUTION.target.path,
  }),
});
